import { TertiaryNavItem, TertiaryNavItemWithIcon } from './types';

export const combineTertiaryNavItems = (
  tertiaryNavItem?: TertiaryNavItem | TertiaryNavItemWithIcon,
  secondaryTertiaryNavItem?: TertiaryNavItem | TertiaryNavItemWithIcon,
  tertiaryNavItems?: (TertiaryNavItem | TertiaryNavItemWithIcon)[]
): (TertiaryNavItem | TertiaryNavItemWithIcon)[] => {
  if (tertiaryNavItems) {
    return tertiaryNavItems;
  }
  const navItems = [];
  if (tertiaryNavItem) {
    navItems.push(tertiaryNavItem);
  }
  if (secondaryTertiaryNavItem) {
    navItems.push(secondaryTertiaryNavItem);
  }
  return navItems;
};
